import axios from "axios"
import { VERSION } from "../config";
const _MODULE = `/mall/${VERSION}/mobile/order`;
export default {
    /***
     * 获取服务时间数据
     */
    getServiceTime(data) {
        return axios({
            url: `${_MODULE}/service_time`,
            method:`POST`,
            data
        })
    },
    /***
     * 获取支付页数据
     */
    getPayPageData(data) {
        return axios({
            url: `${_MODULE}/confirm_page`,
            method:`POST`,
            data
        })
    }
}


// WEBPACK FOOTER //
// ./src/apis/src/orderConfirm.js